import script from "./DiscountTransactionsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountTransactionsSection.vue?vue&type=script&setup=true&lang=ts"

import "./DiscountTransactionsSection.vue?vue&type=style&index=0&id=0536338e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0536338e"]])

export default __exports__